module.exports = __webpack_public_path__ + "static/Symphonia4-4f19ae865478a24e8d2bc189fef75ba5.webp";